var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1773313866483,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6462,
    width: 48,
    height: 48,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 64a448 448 0 1 1 0 896A448 448 0 0 1 512 64zM192 512a320 320 0 0 0 496.448 267.008l-443.456-443.52A318.528 318.528 0 0 0 192 512z m320-320c-65.28 0-125.888 19.52-176.448 52.992l443.456 443.52A320 320 0 0 0 512 192z",
    fill: "#BFBFBF",
    "p-id": 6463
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStill);
export default __webpack_public_path__ + "static/media/Still.ac952c5b8f78cdc64859ba1d35fc7c36.svg";
export { ForwardRef as ReactComponent };